import React from 'react'
import classNames from 'classnames/bind'
import { comparePlansScroller } from 'services/PageScroller'
import { USER_ROLES } from 'constants/user'
import { Text as TextType } from 'hocs/localization'
import ComparePlansTable from 'apps/ComparePlans'
import Heading from 'elements/Heading'
import * as styles from './ComparePlans.scss'

const cx = classNames.bind(styles)

interface IProps {
  t: TextType,
  onSelectSubscriptionPlan: (id: string) => void,
}

const ComparePlans: React.FC<IProps> = ({ t, onSelectSubscriptionPlan, }) => (
  <section id={comparePlansScroller.getElementId()} className={styles.root}>
    <div className='container'>
      <div className='row'>
        <div className='col-md-12'>
          <header className={styles.header}>
            <a href="#compare-plans" id="compare-plans"></a>
            <Heading title={t('header')} size={2} styleType='sectionHeaderAlt' />
          </header>
        </div>
        <div className={cx('col-md-12', 'content')}>
          <ComparePlansTable
            onSelect={onSelectSubscriptionPlan}
            selectPlanOff={[USER_ROLES.subscriptionUser]}
          />
        </div>
      </div>
    </div>
  </section>
)

export default ComparePlans
